/// <reference path="../../_ext/Bases/TransDialog.ts" />
namespace TabAurous.Inventory {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class OpeningStockDialog extends _Ext.TransDialog<OpeningStockRow, any> {

        protected getFormKey() { return OpeningStockForm.formKey; }
        protected getIdProperty() { return OpeningStockRow.idProperty; }
        protected getLocalTextPrefix() { return OpeningStockRow.localTextPrefix; }
        protected getNameProperty() { return OpeningStockRow.nameProperty; }
        protected getService() { return OpeningStockService.baseUrl; }
        protected getDeletePermission() { return OpeningStockRow.deletePermission; }
        protected getInsertPermission() { return OpeningStockRow.insertPermission; }
        protected getUpdatePermission() { return OpeningStockRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new OpeningStockForm(this.idPrefix);

        TaxRegistred: number;
        TaxArray: any[];
        public Closing: boolean = true;
        public RateListId: number = 0;
        public LaborListId: number= 0;
        public StoneMarkup: number= 0;
        public StoneDiscount: number = 0;
        public LaborMarkup: number = 0; 
        public LaborDiscount: number= 0;
        public ExchangeRate: number=1;

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initItemEditor(this, this.form.ItemDetails, Config);

            // #region UI
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            //To Hide Image Toolbar & Label
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            //q.hideCaption(this.form.Posted);
            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.ShipmentId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element); 
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });


            // #endregion


            // **** Get Party Details using PartyID **** 
            this.form.PartyId.changeSelect2(e => {
                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                this.TaxRegistred = parseInt(PartyDetails.TaxRegType);

            });

            //Load Image after Row in Details is Clicked
            var self = this;
            this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {

                var x: Serenity.UploadedFile = {
                    Filename: self.Image,
                    OriginalName: ""
                }
                self.form.ProductItemImage.value = x;
                q.setImageEditorHeight(self.form.ProductItemImage, 160);
            });

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {

                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                if (Items.length == TotalItems) {

                    this.CalculateAmountandTax(Items, ItemTotal);
                }
            });

            this.form.GrossAmount.addValidationRule(this.uniqueName, x => {
                var items = this.form.ItemDetails.getItems();

                items.forEach(function (value) {
                    value.BOMDetails.forEach(function (bom) {
                        if (bom.BomAmount == null || bom.BomAmount <= 0) {
                            return "BOM must Have rate!!";
                        }

                    })
                })


                if (items.length <= 0)
                    return "Select at least one item";

            });

            this.validateForm();

        }

        // **** Total Weight, Amount and TAX Calculation ****
        public CalculateAmountandTax(Items: any, ItemTotal: number ) {

            var HSN = [];
            var Amount = [];
            var TaxDetail = [];

            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0; var tds = 0;

            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                var temp = false;
                for (let i = 0; i < HSN.length; i++) {
                    if (HSN[i] == x.TaxCode) {
                        Amount[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    HSN.push(x.TaxCode);
                    Amount.push(x.GrossAmount);
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            //   this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == 2)[0].IsTaxApplicable;

              
                this.form.GrossAmount.value = gramt;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt; 
        }

        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.CompanyId.value != 0 || this.form.FinancialYearId.value != 0) {
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
            }
            if (this.form.PartyId.value != "") {
                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.TaxRegistred = parseInt(PartyDetails.TaxRegType);
                this.form.ItemDetails.canUpdate = 0;
            }
        }

        // **** Get Set Toolbar Buttons **** 
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: '',
                cssClass: 'export-pdf-button',
                reportKey: 'Reports.OpeningStock',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));
            var postingpermission = Q.Authorization.hasPermission('Inventory:OpeningStock:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    OpeningStockService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }

        // #region Edit Delete Validation
  
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                OpeningStockService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }

        validateBeforeSave() {
            super.validateBeforeSave();
            var Isvalid = super.validateBeforeSave();
            if (this.form.ItemDetails.getItems().length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                Isvalid = false;
            }
            for (var i = 0; i < this.form.ItemDetails.getItems().length; i++) {
                let items = this.form.ItemDetails.getItems();
                //if (items[i].ImageName == null || items[i].ImageName == "") {
                //    var msg = q.text('', 'Image not set, Can not Save!') + items[i].ProductCode;
                //    Q.alert(msg)
                //    Isvalid = false;
                //}
                if (items[i].HasBom) {
                    items[i].BOMDetails.forEach(function (x) {
                        if (x.ProductId == null || x.ProductId.toString() == "")
                            x.ProductId = items[i].ProductId;

                        if (x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
                            var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component "' + items[i].ProductCode + '", Cannot Save!');
                            Q.alert(msg)
                            Isvalid = false;
                        }
                        if (x.Weight == null || x.Weight == 0 ) {
                            var msg = q.text('Message.Component.WeightNotDefine', 'Weight can not Zero, Cannot Save!');
                            Q.alert(msg)
                            Isvalid = false;
                        }
                    })
                }
                if (Isvalid) {
                    var mfvalidation = q.ToBool(TabAurous.GetConfigValue(1022));  
                    if (mfvalidation == true) {
                        if (items[i].MF == null || items[i].MF == 0 || items[i].MFAmount == null || items[i].MFAmount == 0) {
                            var msg = q.text('Message.Component.MFDefined', 'MF not Defined for Component, Can not Save! ') + items[i].ProductCode;
                            Q.warning(msg)
                            Isvalid = false;
                        }
                    }
                }

                if (items[i].LaborDetails != null && items[i].LaborDetails.length > 0) {
                    items[i].LaborDetails.forEach(function (x) {
                        if (x.LabourRate == null|| x.LabourRate <= 0 || x.LabourAmount == null || x.LabourAmount <= 0) {
                            Q.alert("Rate not Defined for labor, Can not Save!")
                            Isvalid = false;
                        }
                    })
                }
            }

            return Isvalid;

        }


        // #endregion
        validateEntity(row: OpeningStockRow, id: number) {

            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, Atleast add one entry. Can not Save! ")
                return false;
            }
            for (var i = 0; i < row.ItemDetails.length; i++) {
                row.ItemDetails[i].BOMDetails.forEach(function (x) {
                    if (x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
                        Q.alert("Rate not Defined for Component, Can not Save!")
                        return false;
                    }
                })

                if (row.ItemDetails[i].LaborDetails.length > 0) {
                    row.ItemDetails[i].LaborDetails.forEach(function (x) {
                        if (x.LabourRate == null|| x.LabourRate <= 0 || x.LabourAmount == null || x.LabourAmount <= 0) {
                            Q.alert("Rate not Defined for labour, Can not Save!")
                            return false;
                        }
                    })
                }
            }

            return true;
        } 
    }
}